import { ExportButton } from '../components/ExportButton';
import { PageHeader } from '../components/PageHeader';
import { workflowTemplates } from '../lib/seedData';

export function WorkflowPage() {
  const workflow = workflowTemplates[0];

  return (
    <section className="page">
      <PageHeader title="Workflow template viewer" description={workflow.description} actions={<ExportButton label="Export workflow" />} />
      <div className="card timeline">
        {workflow.steps.map((step, index) => (
          <div className="timeline-item" key={step.id}>
            <div className="timeline-index">{index + 1}</div>
            <div>
              <h2 className="section-title">{step.name}</h2>
              <p className="muted">{step.owner} owned</p>
              <p>{step.description}</p>
              {step.evidenceOutput ? <span className="badge good">{step.evidenceOutput}</span> : null}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
